/** En-tête par lequel le frontend transmet le jeton GitLab de l'utilisateur au backend. */
export const USER_TOKEN_HEADER = 'x-platform-gitlab-token';
